export const clearChatWidgetStorage = () => {
  if (typeof window === "undefined") return;

  Object.keys(window.localStorage).forEach((key) => {
    if (key === "chat_messages" || key.startsWith("chat_messages_")) {
      window.localStorage.removeItem(key);
    }
  });

  window.sessionStorage.removeItem("CHAT_ACTION");
};
